import React from 'react'

const CheckInCountIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <defs />
      <path
        fill={color}
        d="M353.924 125.62c-1.7 1-3.7 2.8-4.2 3.9-2.4 4.5-.3 12.9 3.8 15.1 1.2.6 12 1 27.8 1h25.9l2.8-2.8c3.4-3.7 4.3-8.9 2.2-13-3-5.8-5-6.2-31.3-6.2-21.8 0-24.1.2-27 2zM121.414 128.422c-3.66 3.7-4.14 11.9-1.02 17.3l1.62 2.8h172.32l1.68-2.8c2.04-3.7 2.58-8.9 1.32-13-2.04-6.6 4.14-6.2-89.28-6.2-81.9 0-84.84.1-86.64 1.9zM118.877 70.312c-6.1 3.7-6.9 11.9-1.7 17.3l2.7 2.8h287.2l2.8-2.8c3.4-3.7 4.3-8.9 2.2-13-3.4-6.6 6.9-6.2-148.8-6.2-136.5 0-141.4.1-144.4 1.9z"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fill={color}
        d="M93.96 1.668c-8 2.1-14.7 6.1-22.4 13.3-7.8 7.4-13.8 18.3-15.6 28.5-1.5 8.3-1.5 416.9 0 425.2 1.8 10.2 7.8 21.1 15.6 28.5 3.8 3.5 9.1 7.6 11.9 9.1 11.3 6.1.9 5.8 185.4 5.8 184.4 0 174 .3 185.4-5.8 2.8-1.5 8.4-5.9 12.4-9.8 8.1-8.1 13.2-17.4 15.1-27.8 1.5-8.3 1.5-416.7 0-425.2-1.8-10.2-7.8-21.1-15.6-28.5-7.8-7.3-14.4-11.2-22.8-13.4-8.7-2.2-341-2.2-349.4.1zm348.5 23.6c6.7 3.5 13.8 11.5 16.1 18.1 1.7 5 1.8 14.6 1.8 212.7s-.1 207.7-1.8 212.7c-2.3 6.6-9.4 14.6-16.1 18.1l-5.1 2.7h-337l-5.1-2.7c-6.7-3.5-13.8-11.5-16.1-18.1-1.7-5-1.8-14.6-1.8-212.7s.1-207.7 1.8-212.7c3.1-8.8 12.3-17.5 21.7-20.4 1.4-.4 77.6-.7 169.5-.6l167 .2 5.1 2.7z"
        vectorEffect="non-scaling-stroke"
      />
      <path
        fill={color}
        stroke="null"
        strokeWidth=".1"
        d="M272.54 174.756c-2.451.45-5.065 1.743-6.844 3.429-.781.73-15.225 17.31-32.122 36.812-16.869 19.502-30.774 35.52-30.909 35.632-.134.085-4.689-3.85-10.132-8.711-10.456-9.358-11.803-10.341-15.172-11.072-4.931-1.068-10.32.59-13.878 4.3-5.686 5.957-7.464 9.442-7.464 14.78 0 3.738 1.024 6.998 3.072 9.696.97 1.264 35.301 34.17 37.43 35.829 1.833 1.46 4.123 2.388 6.818 2.81 4.204.646 8.785-.815 11.884-3.738 1.86-1.798 75.4-90.85 76.559-92.733 1.536-2.558 1.994-4.216 2.155-7.784.108-2.951.054-3.429-.592-5.424-.405-1.208-1.132-2.866-1.617-3.653-1.375-2.22-6.252-6.885-8.812-8.43-2.83-1.715-6.818-2.39-10.375-1.743z"
      />
      <path
        fill={color}
        stroke="null"
        d="M360.484 319.016v131.5H411v-263h-50.516v131.5zM285.148 345.984v104.532h50.516V241.452h-50.516v104.532z"
      />
      <path
        fill={color}
        stroke="null"
        d="M281.148 345.984v104.532h50.516V241.452h-50.516v104.532zM126 375.209v77.307h50.516V297.901H126v77.308zM203.336 401.176v50.34h50.516v-100.68h-50.516v50.34z"
      />
      <path
        fill={color}
        d="M125.924 182.62c-1.7 1-3.7 2.8-4.2 3.9-2.4 4.5-.3 12.9 3.8 15.1 1.2.6 12 1 27.8 1h25.9l2.8-2.8c3.4-3.7 4.3-8.9 2.2-13-3-5.8-5-6.2-31.3-6.2-21.8 0-24.1.2-27 2z"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}

CheckInCountIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default CheckInCountIcon
